var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.739,
    height: 61.684,
    viewBox: "0 0 62.739 61.684",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "talk",
    transform: "translate(0 -0.774)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_110",
    "data-name": "Ellipse 110",
    cx: 6.191,
    cy: 6.191,
    r: 6.191,
    transform: "translate(1.708 0.775)",
    fill: "#df9426"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_111",
    "data-name": "Ellipse 111",
    cx: 6.191,
    cy: 6.191,
    r: 6.191,
    transform: "translate(48.649 0.775)",
    fill: "#df9426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11846",
    "data-name": "Path 11846",
    d: "M0,34.016V55.6a4.9,4.9,0,0,0,4.339,4.869l8.279.956v11.6h9.8V57.06a4.9,4.9,0,0,0-4.339-4.869L9.8,51.235V48.8A5.881,5.881,0,0,1,7.83,46.834Z",
    transform: "translate(0 -10.573)",
    fill: "#df9426",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11847",
    "data-name": "Path 11847",
    d: "M81.543,34.016l-7.83,12.818A5.9,5.9,0,0,1,71.74,48.8v2.435l-8.279.956a4.9,4.9,0,0,0-4.339,4.869V73.03h9.8v-11.6l8.279-.956A4.9,4.9,0,0,0,81.543,55.6Z",
    transform: "translate(-18.804 -10.573)",
    fill: "#df9426",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11848",
    "data-name": "Path 11848",
    d: "M2.1,29.406l7.961,13.032a3.851,3.851,0,0,0,4.716,1.568l12.44-4.972a3.851,3.851,0,0,0-2.859-7.152l-9.42,3.766L8.677,25.39A3.851,3.851,0,1,0,2.1,29.406Z",
    transform: "translate(-0.49 -7.243)",
    fill: "#df9426",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11849",
    "data-name": "Path 11849",
    d: "M70.336,25.39,63.322,36.871,52.939,38.339a3.851,3.851,0,1,0,1.079,7.626L66.2,44.243a3.851,3.851,0,0,0,2.748-1.805l7.961-13.032a3.851,3.851,0,0,0-6.573-4.015Z",
    transform: "translate(-15.784 -7.243)",
    fill: "#df9426",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11850",
    "data-name": "Path 11850",
    d: "M50.1,2.82A2.045,2.045,0,0,0,48.059.774H33.788A2.046,2.046,0,0,0,31.742,2.82v13a.682.682,0,0,0,1.13.514L36.015,13.6a2.045,2.045,0,0,1,1.344-.5h10.7A2.045,2.045,0,0,0,50.1,11.046Zm-13.739,7h4.557a1.023,1.023,0,1,0,0-2.046H36.366a1.023,1.023,0,1,0,0,2.046Zm0-3.73h9.269a1.023,1.023,0,0,0,0-2.046H36.366a1.023,1.023,0,1,0,0,2.046Z",
    transform: "translate(-10.096)",
    fill: "#df9426",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalkIcon);
export default __webpack_public_path__ + "static/media/talk_icon.66f6348c7995407611288fccdeed362c.svg";
export { ForwardRef as ReactComponent };